export function debounce(func, wait, immediate = false) {
  let timeout;

  return function (...args) {
    const context = this;

    // 清除之前的定时器
    if (timeout) clearTimeout(timeout);

    // 如果立即执行，并且没有定时器，则立即调用函数
    if (immediate && !timeout) {
      func.apply(context, args);
    }

    // 设置新的定时器
    timeout = setTimeout(() => {
      timeout = null; // 清除定时器
      if (!immediate) {
        func.apply(context, args); // 非立即执行时调用函数
      }
    }, wait);
  };
}